export default __webpack_public_path__ + "static/MarkM-74430507bcf54ece68c8e9076adc23a5.png";